import { render, staticRenderFns } from "./hospitalDetail.vue?vue&type=template&id=4987b10c&scoped=true"
import script from "./hospitalDetail.vue?vue&type=script&lang=js"
export * from "./hospitalDetail.vue?vue&type=script&lang=js"
import style0 from "./hospitalDetail.vue?vue&type=style&index=0&id=4987b10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987b10c",
  null
  
)

export default component.exports